import { Pages } from '@/webiny/queries';
import { handleGetStaticProps } from '@/webiny/api';
import { fallbackData as fb } from './constants';

const { getNodesPage } = Pages;

export const getStaticProps = handleGetStaticProps(getNodesPage, fb);

export { default } from './Nodes';
